import {
  Header,
  HeroSection,
  OperationsSection,
  CenterSection,
  MobileExperienceSection,
  CyberSecuritySection,
  IntegrationProcessSection,
  AboutSection,
  StorySection,
  ValuesSection,
  TeamSection,
  NumbersSection,
  TechSection,
  CustomersSection,
  CTASection,
  FAQSection,
  Footer,
} from '../components';

export function Home() {
  return (
    <div className="min-h-screen bg-base-gray">
      {/* Header */}
      <Header title="CommerceMinder" />

      {/* Hero Section */}
      <div className="pt-16">
        <HeroSection />
      </div>

      {/* Operations Section */}
      <OperationsSection />

      {/* Center Section */}
      <CenterSection />

      {/* Mobile Experience Section */}
      <MobileExperienceSection />

      {/* Cyber Security Section */}
      <CyberSecuritySection />

      {/* Integration Process Section */}
      <IntegrationProcessSection />

      {/* About Section */}
      <AboutSection />

      {/* Story Section */}
      <StorySection />

      {/* Values Section */}
      <ValuesSection />

      {/* Team Section */}
      <TeamSection />

      {/* Numbers Section */}
      <NumbersSection />

      {/* Tech Section */}
      <TechSection />

      {/* Customers Section */}
      <CustomersSection />

      {/* CTA Section */}
      <CTASection />

      {/* FAQ Section */}
      <FAQSection />

      {/* Footer */}
      <Footer />
    </div>
  );
}
